"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/styles");

var _clsx2 = _interopRequireDefault(require("clsx"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSimpleMaps = require("react-simple-maps");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var styles = {
  root: {},
  shape: {
    fill: "#eee",
    stroke: "#fff"
  },
  hovered: {
    fill: "#f6f6f6"
  },
  selected: {}
};

var Shapes = function Shapes(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      selected = _ref.selected,
      hovered = _ref.hovered,
      geographies = _ref.geographies,
      onHover = _ref.onHover,
      onSelect = _ref.onSelect,
      _ref$isHoveredMatch = _ref.isHoveredMatch,
      isHoveredMatch = _ref$isHoveredMatch === void 0 ? function (geo, hovered) {
    return hovered && geo.rsmKey === hovered.rsmKey;
  } : _ref$isHoveredMatch,
      _ref$isSelectedMatch = _ref.isSelectedMatch,
      isSelectedMatch = _ref$isSelectedMatch === void 0 ? function (geo, selected) {
    return selected && geo.rsmKey === selected.rsmKey;
  } : _ref$isSelectedMatch,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["classes", "className", "selected", "hovered", "geographies", "onHover", "onSelect", "isHoveredMatch", "isSelectedMatch", "children"]);

  return /*#__PURE__*/_react["default"].createElement("g", _extends({
    className: (0, _clsx2["default"])("svg-map__shapes", classes.root, className)
  }, props), geographies.map(function (geo) {
    var _clsx;

    return /*#__PURE__*/_react["default"].createElement(_reactSimpleMaps.Geography, {
      className: (0, _clsx2["default"])("svg-map__geography", classes.shape, (_clsx = {}, _defineProperty(_clsx, classes.hovered, isHoveredMatch(geo, hovered)), _defineProperty(_clsx, classes.selected, isSelectedMatch(geo, selected)), _clsx)),
      key: geo.rsmKey,
      geography: geo,
      onClick: function onClick(e) {
        onSelect && onSelect(geo, e);
      },
      onMouseEnter: function onMouseEnter(e) {
        onHover && onHover(geo, e);
      },
      onMouseLeave: function onMouseLeave(e) {
        onHover && onHover(null, e);
      }
    });
  }), children);
};

Shapes.propTypes = {
  /** Object of class names for the map */
  classes: _propTypes["default"].object,

  /** Root class name for the map */
  className: _propTypes["default"].string,

  /** geography currently hovered */
  hovered: _propTypes["default"].object,

  /** geography currently selected */
  selected: _propTypes["default"].object,

  /** handler function for hover events */
  onHover: _propTypes["default"].func,

  /** handler for selecting a location */
  onSelect: _propTypes["default"].func,

  /** function for determining if a geography matches hovered */
  isHoveredMatch: _propTypes["default"].func,

  /** function for determining if a geography matches selected */
  isSelectedMatch: _propTypes["default"].func
};

var _default = (0, _styles.withStyles)(styles, {
  name: "HypSvgMapShapes"
})(Shapes);

exports["default"] = _default;